export const CREATE_PRODUCT_REQUEST = "CREATE_PRODUCT_REQUEST";
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_FAIL = "CREATE_PRODUCT_FAIL";
export const CREATE_PRODUCT_RESET = "CREATE_PRODUCT_RESET";

export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAIL = "UPDATE_PRODUCT_FAIL";
export const UPDATE_PRODUCT_RESET = "UPDATE_PRODUCT_RESET";


export const ALL_PRODUCTS_REQUEST = "ALL_PRODUCTS_REQUEST";
export const ALL_PRODUCTS_SUCCESS = "ALL_PRODUCTS_SUCCESS";
export const ALL_PRODUCTS_FAIL = "ALL_PRODUCTS_FAIL";

export const SINGLE_PRODUCT_REQUEST = "SINGLE_PRODUCT_REQUEST";
export const SINGLE_PRODUCT_SUCCESS = "SINGLE_PRODUCT_SUCCESS";
export const SINGLE_PRODUCT_FAIL = "SINGLE_PRODUCT_FAIL";


export const BLOCK_PRODUCT_REQUEST = "BLOCK_PRODUCT_REQUEST";
export const BLOCK_PRODUCT_SUCCESS = "BLOCK_PRODUCT_SUCCESS";
export const BLOCK_PRODUCT_RESET = "BLOCK_PRODUCT_RESET";
export const BLOCK_PRODUCT_FAIL = "BLOCK_PRODUCT_FAIL";

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_RESET = "DELETE_PRODUCT_RESET";
export const DELETE_PRODUCT_FAIL = "DELETE_PRODUCT_FAIL";


export const MULTI_PRODUCT_UPDATE_REQUEST = "MULTI_PRODUCT_UPDATE_REQUEST";
export const MULTI_PRODUCT_UPDATE_SUCCESS = "MULTI_PRODUCT_UPDATE_SUCCESS";
export const MULTI_PRODUCT_UPDATE_RESET = "MULTI_PRODUCT_UPDATE_RESET";
export const MULTI_PRODUCT_UPDATE_FAIL = "MULTI_PRODUCT_UPDATE_FAIL";



export const CLEAR_ERRORS = "CLEAR_ERRORS";
